import { MultiSelect as PrimeMultiSelect } from "primereact/multiselect";
import { classNames } from "primereact/utils";
import { forwardRef } from "react";

import { withDefaults } from "../../utils/with-defaults";
import { SELECT_FILTER_PLACEHOLDER, withSelectPanelScrollBar } from "../dropdown";
import { primeIcon } from "../icon";
import styles from "./multi-select.module.scss";
import { searchFilterTemplate } from "./search-filter-template";
import type { MultiSelectProps } from "./types-multi-select";

/** Debounce padrão do filtro do Prime. */
const FILTER_DELAY_MS = 300;

const CHECK_ICON = primeIcon("check", 14);

export const MULTI_SELECT_SELECTED_LABEL = "{0} selecionados";

/**
 * Padrões do Figma: gatilho, limpar, chip (times-circle 16, Chip 334:13139, só com `display="chip"`), itens (check 14 do Checkbox),
 * busca e fechar. Com 1 item o campo mostra o rótulo dele; com 2 ou mais, "N selecionados".
 */
const FIGMA_DEFAULTS = {
  display: "comma" as const,
  maxSelectedLabels: 1,
  selectedItemsLabel: MULTI_SELECT_SELECTED_LABEL,
  dropdownIcon: primeIcon("chevron-down", 14),
  clearIcon: primeIcon("times-circle", 14),
  filterTemplate: searchFilterTemplate,
  removeIcon: primeIcon("times-circle", 16),
  checkboxIcon: CHECK_ICON,
  itemCheckboxIcon: CHECK_ICON,
  closeIcon: primeIcon("times", 14),
  filterPlaceholder: SELECT_FILTER_PLACEHOLDER,
  filterDelay: FILTER_DELAY_MS,
};

/** `MultiSelect` do Prime com resumo "N selecionados", ícones, mensagens em pt-BR e tamanho do Figma como padrão (a tela sobrescreve por prop). */
export const MultiSelect = forwardRef<PrimeMultiSelect, MultiSelectProps>(function MultiSelect(
  { id, inputId, size, className, ...props },
  ref,
) {
  return (
    <PrimeMultiSelect
      ref={ref}
      {...withDefaults({ ...FIGMA_DEFAULTS, appendTo: document.body }, props)}
      {...withSelectPanelScrollBar("multiselect", props)}
      inputId={inputId ?? id}
      className={classNames(
        styles.root,
        size === "sm" && "p-multiselect-sm",
        size === "lg" && "p-multiselect-lg",
        className,
      )}
    />
  );
});
MultiSelect.displayName = "MultiSelect";
